import React, { useRef } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import cn from 'classnames';
import { useSafeAreaModifier } from '@dyl/systems/SafeAreaManager';
import useRectProperties from '@dyl/hooks/useRectProperties';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'fixed',
        bottom: theme.spacing(3),
        right: theme.spacing(3),

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',

        '&>:not(:last-child)': {
            marginRight: theme.spacing(2),
        },
    },
}));

/**
 * Container fixed to the bottom-right of the screen, for displaying actions.
 */
export default function ScreenActions({ children, className: propsClass, inline = false, ...other }) {
    const classes = useStyles(other);

    /** @type {React.MutableRefObject<HTMLDivElement>} */
    const ref = useRef();
    const safeInset = useRectProperties(ref, rect => inline ? 0 : window.innerHeight - rect.top);

    useSafeAreaModifier('bottom', 'min', safeInset);
    return (
        <div
            ref={ref}
            className={cn(inline ? null : classes.root, propsClass)}
            {...other}
        >
            {children}
        </div>
    );
}